module.exports = "/img/cec852667677ed5b9ddd548e4b3d8153.png";